import { Modal } from "antd";
import { useState } from "react";
interface AddEditVersion {
    taskDetails:any;
    // isEdit:boolean;
    onClosePopup: () => void;

  }
    const RejectComments: React.FC<AddEditVersion> = ({taskDetails ,onClosePopup}) => {

    const [isOpen,setIsOpen] = useState<boolean>(true);
    const closeDetails = () => {
        setIsOpen(false)
        onClosePopup()
    }
    return <>
     <Modal open={isOpen} maskClosable={false} title="Reason for Rejection" onCancel={closeDetails} footer={false}>
{taskDetails.comments}

        </Modal>
    </>
   
}

export default RejectComments;